import * as StyledComponents from '../UnifyAdministration/StyledComponents';
import { LinkSheetDetails } from './LinksSheetDetails';
import styled from "styled-components";
import {
  CustomScrollbarWrapper,
} from 'cdk-radial';


export const StyledCustomScrollbarWrapper = styled(CustomScrollbarWrapper)`
  height: calc(100% - 10px);
  overflow-x: hidden;
`;


export const LinkSideSheetBody = (): JSX.Element => {
  return (
    <StyledComponents.StyledSideSheetBodyContainer>
      <StyledCustomScrollbarWrapper>
      <LinkSheetDetails />
      </StyledCustomScrollbarWrapper>
    </StyledComponents.StyledSideSheetBodyContainer>
  );
};